import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useEffect } from 'react';
import classNames from 'classnames';
import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import RadioGroupContext from './context';
import devWarning from '../_utils/devwarning';

var InternalRadio = function InternalRadio(props, ref) {
  var _classNames;

  var context = React.useContext(RadioGroupContext);

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      prefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var innerRef = React.useRef();
  var mergedRef = ref || innerRef;

  var _a = getCompProps('Radio', userDefaultProps, props),
      style = _a.style,
      checked = _a.checked,
      children = _a.children,
      className = _a.className,
      radioType = _a.radioType,
      value = _a.value,
      disabled = _a.disabled,
      defaultChecked = _a.defaultChecked,
      customPrefixcls = _a.prefixCls,
      restProps = __rest(_a, ["style", "checked", "children", "className", "radioType", "value", "disabled", "defaultChecked", "prefixCls"]); // 属性需要合并一遍用户定义的默认属性


  devWarning(!(isNumber(value) || isString(value)) && value !== '', 'radio', 'radio `value` type must string or number ');
  devWarning(value === '', 'radio', 'radio value type is not empty string ');
  var mergedDisabled = (context === null || context === void 0 ? void 0 : context.disabled) || restProps.disabled;
  var initValue = context ? value === context.value : isBoolean(checked) ? checked : defaultChecked;

  var getPrefix = function getPrefix(radioType) {
    return "radio".concat(radioType === 'square' ? "-".concat(radioType) : '');
  };

  var radioPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, getPrefix(radioType), customPrefixcls); // 样式前缀

  var _React$useState = React.useState(initValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isChecked = _React$useState2[0],
      setIsChecked = _React$useState2[1];

  React.useEffect(function () {
    var checkedValue = context ? value === context.value : isBoolean(checked) ? checked : defaultChecked;
    setIsChecked(checkedValue);
  }, [checked, defaultChecked, context === null || context === void 0 ? void 0 : context.value]);

  var onChange = function onChange(e) {
    setIsChecked(e.target.checked);

    if (props.onChange) {
      props.onChange(e);
    }

    if (context === null || context === void 0 ? void 0 : context.onChange) {
      context.onChange(e, value);
    }
  };

  var classString = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(radioPrefixCls), true), _defineProperty(_classNames, "".concat(radioPrefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(radioPrefixCls, "-checked"), isChecked), _classNames), className); // 单选包裹元素class名称

  useEffect(function () {
    var _a;

    var handleRepeatClick = function handleRepeatClick(e) {
      var element = e.target;

      if (element.tagName !== 'INPUT') {
        e.stopPropagation();
      }
    };

    var radioRef = mergedRef;
    (_a = radioRef === null || radioRef === void 0 ? void 0 : radioRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', handleRepeatClick);
    return function () {
      var _a; // eslint-disable-next-line react-hooks/exhaustive-deps


      (_a = radioRef === null || radioRef === void 0 ? void 0 : radioRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', handleRepeatClick);
    };
  }, []);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    React.createElement("label", {
      className: classString,
      style: style,
      ref: mergedRef
    }, /*#__PURE__*/React.createElement("input", _extends({
      type: "radio",
      className: "".concat(radioPrefixCls, "-input"),
      checked: isChecked,
      onChange: onChange,
      value: value,
      name: context === null || context === void 0 ? void 0 : context.name,
      disabled: mergedDisabled
    }, restProps)), children !== undefined ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(radioPrefixCls, "-text")
    }, children) : null)
  );
};

var Radio = /*#__PURE__*/React.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
export default Radio;